import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { format } from "date-fns";
import LoadingAnimation from "../components/LoadingAnimation";
import api from "../utils/api";

function AnnoucementDetails() {
  const { annoucementid } = useParams();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    api
      .get(`/api/announcements/${annoucementid}`)
      .then((res) => {
        setAnnouncement(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch announcement detail:", err);
        setLoading(false);
      });
  }, [annoucementid]);

  if (loading) {
    return (
      <LoadingAnimation />
    );
  }

  if (!announcement) {
    return (
      <div className="p-6 text-center text-red-600">
        Announcement not found.
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-7xl mx-auto p-6 sm:p-8 bg-white rounded-2xl shadow-lg mt-6"
    >
      <h1 className="text-3xl font-bold text-slate-800 mb-4">
        {announcement.title}
      </h1>

      <p className="text-sm text-gray-500 mb-6">
        Published on{" "}
        {format(new Date(announcement.createdAt), "do MMMM yyyy, h:mm a")}
      </p>

      <hr className="border-gray-200 mb-6" />

      <div
        className="rendered-html text-gray-800 text-base leading-relaxed whitespace-pre-line"
        dangerouslySetInnerHTML={{ __html: announcement.description }}
      />
    </motion.div>
  );
}

export default AnnoucementDetails;
